import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../configure_store'
import { DEFAULT_PINCODE_ICON } from '../../utils/pincode_icon'

const _getState = (state: RootState) => state.setup

export const getPincode = createSelector(
  _getState,
  (state) => state.pincode
)

export const getPincodeIcon = createSelector(
  _getState,
  (state) => state.pincodeIcon ?? DEFAULT_PINCODE_ICON
)

export const getThemeMode = createSelector(
  _getState,
  (state) => state.themeMode
)
